import axios from 'axios'

const endpoint =
  process.env.VUE_APP_CHATBOT_ECHO_ENDPOINT ||
  'https://newapi.webreceita.com.br/webreceita/api/v1/chatbot/echo'

export default {
  sendMessage(token, text) {
    const headers = {}
    if (token) {
      headers.Authorization = token
    }

    return axios.post(
      endpoint,
      {
        text,
      },
      { headers }
    )
  },
}
